module.exports = __webpack_public_path__ + "static/media/f_id_back.5963292d.svg";